export default class chooseActionController {
  /** @ngInject */
  constructor(
    $log, $mdDialog
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
  }

  cancel() {
    this.$mdDialog.cancel();
  }

  hide(isPeriod) {
    this.$mdDialog.hide(isPeriod);
  }
}
